export const getBaggageFromFare = (fare, fallbackSegments) => {
	const seg = fallbackSegments?.[0];
	const baggage = fare?.baggage;
	return {
		checkin: baggage?.checkin ?? seg?.checkinBaggage,
		cabin: baggage?.cabin ?? seg?.cabinBaggage,
	};
};

export const applyBaggageToSegments = (segments, baggage) => {
	if (!baggage || !segments) return segments;
	return segments.map((seg) => ({
		...seg,
		checkinBaggage: baggage.checkin ?? seg.checkinBaggage,
		cabinBaggage: baggage.cabin ?? seg.cabinBaggage,
		childCheckinBaggage: baggage.childCheckin ?? seg.childCheckinBaggage,
		childCabinBaggage: baggage.childCabin ?? seg.childCabinBaggage,
		infantCheckinBaggage: baggage.infantCheckin ?? seg.infantCheckinBaggage,
		infantCabinBaggage: baggage.infantCabin ?? seg.infantCabinBaggage,
	}));
};

const applySelectedFareToSegments = (segments, selectedFare) =>
	applyBaggageToSegments(segments, selectedFare.baggage).map((seg) => ({
		...seg,
		cabinClass: selectedFare.cabinClass ?? seg.cabinClass,
	}));

export const mergeFlightWithSelectedFare = (flight, selectedFare) => {
	if (!selectedFare) return flight;
	const merged = { ...flight, selectedFare };
	if (flight.segments) {
		merged.segments = applySelectedFareToSegments(flight.segments, selectedFare);
	}
	if (flight.onwardSegments) {
		merged.onwardSegments = applySelectedFareToSegments(flight.onwardSegments, selectedFare);
	}
	if (flight.returnSegments) {
		merged.returnSegments = applySelectedFareToSegments(flight.returnSegments, selectedFare);
	}
	return merged;
};
